import { boxShadow, Button, Icon, pxToRem, Text } from "@ottatech/design";
import styled from "styled-components";

const ActionButton = styled(Button)`
  padding: ${pxToRem(11)} ${pxToRem(20)};
  box-shadow: ${boxShadow};
  :hover {
    text-decoration: none;
  }
`;

const StyledIcon = styled(Icon)`
  margin-right: ${pxToRem(8)};
`;

type INextAndApplyButtonsProps = INextButtonProps &
  IApplyButtonProps & { canApply: boolean };

interface INextButtonProps {
  handleNext: () => void;
}

interface IApplyButtonProps {
  handleApply: () => void;
}

const NextButton = ({ handleNext }: INextButtonProps) => {
  return (
    <ActionButton
      level="secondary"
      data-analytics-id="public-job-action-panel-next-button"
      onClick={handleNext}
    >
      <StyledIcon icon="chevron-right" size={1} />
      <Text bold>Next job</Text>
    </ActionButton>
  );
};

const ApplyButton = ({ handleApply }: IApplyButtonProps) => (
  <ActionButton
    level="primary"
    data-testid="public-job-apply-button"
    data-analytics-id="public-job-action-panel-apply-button"
    onClick={handleApply}
  >
    <StyledIcon icon="apply" size={0.1} />
    <Text bold>Apply</Text>
  </ActionButton>
);

export const NextAndApplyButtons = ({
  handleNext,
  handleApply,
  canApply,
}: INextAndApplyButtonsProps): React.ReactElement => (
  <>
    {canApply && <ApplyButton handleApply={handleApply} />}
    <NextButton handleNext={handleNext} />
  </>
);
